import { TradeTrustToken__factory } from '../../token-registry-v4/contracts';
import { getEthersContractFromProvider } from '../../utils/ethers';
import { sortLogChain } from '../endorsement-chain/helpers';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const fetchTokenTransfers = /* @__PURE__ */ __name(async (provider, tokenRegistryAddress, tokenId) => {
  const Contract = getEthersContractFromProvider(provider);
  const tokenRegistryContract = new Contract(
    tokenRegistryAddress,
    TradeTrustToken__factory.abi,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    provider
  );
  const logs = await fetchLogs(tokenRegistryContract, tokenId);
  const parsedLogs = parseLogs(logs, tokenRegistryContract);
  const reformattedLogs = parsedLogs.map(
    (event) => formatTokenTransferEvent(event, tokenRegistryAddress)
  );
  sortLogChain(reformattedLogs);
  return reformattedLogs;
}, "fetchTokenTransfers");
async function fetchLogs(tokenRegistry, tokenId) {
  const transferLogFilter = tokenRegistry.filters.Transfer(null, null, tokenId);
  const logs = await tokenRegistry.queryFilter(transferLogFilter, 0);
  if (logs.length === 0) {
    throw new Error("Unminted Title Escrow");
  }
  return logs;
}
__name(fetchLogs, "fetchLogs");
const parseLogs = /* @__PURE__ */ __name((logs, tokenRegistry) => {
  return logs.map((log) => {
    if (!log.args) throw new Error(`Transfer log malformed: ${log}`);
    if (!log.blockNumber) throw new Error("Block number not present");
    if (!log.transactionHash) throw new Error("Transaction hash not present");
    return {
      ...log,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...tokenRegistry.interface.parseLog(log)
    };
  });
}, "parseLogs");
const formatTokenTransferEvent = /* @__PURE__ */ __name((event, tokenRegistryAddress) => {
  const type = identifyTokenTransferEvent(event, tokenRegistryAddress);
  return {
    type,
    from: event.args.from,
    to: event.args.to,
    blockNumber: event.blockNumber,
    transactionHash: event.transactionHash,
    transactionIndex: event.transactionIndex
  };
}, "formatTokenTransferEvent");
const identifyTokenTransferEvent = /* @__PURE__ */ __name((log, tokenRegistryAddress) => {
  const InitialAddress = "0x0000000000000000000000000000000000000000";
  const BurnAddress = "0x000000000000000000000000000000000000dEaD";
  const { from, to } = log.args;
  if (to === tokenRegistryAddress) return "SURRENDERED";
  if (to === BurnAddress) return "SURRENDER_ACCEPTED";
  if (from === tokenRegistryAddress) return "SURRENDER_REJECTED";
  if (from === InitialAddress) return "INITIAL";
  throw new Error("Unidentified transfer event");
}, "identifyTokenTransferEvent");

export { fetchTokenTransfers };
